import { ReaTechnicalDetailItem } from 'src/app/models/fincas/rea.model';

export interface ReaCurrentErrorSupportEmailData {
  fincaName: string;
  nif: string;
  codigoRea: string;
  title: string;
  description: string;
  nextStep: string;
  technicalDetails: ReaTechnicalDetailItem[];
}

export interface ReaAuditSupportEmailData {
  importId: string;
  createdAt: string;
  nif: string;
  codigoRea: string;
  statusCode: number;
  title: string;
  description: string;
  nextStep: string;
  technicalDetails: ReaTechnicalDetailItem[];
}

/**
 * Builds support email links with the current REA error context.
 */
export class ReaSupportEmailPresenter {
  private static readonly supportEmail = 'soporte@locatec.es';

  public static currentErrorHref(data: ReaCurrentErrorSupportEmailData): string {
    return this.buildMailto(`Soporte REA - ${data.title}`, [
      'Hola,',
      '',
      'Necesito ayuda con este error de importación REA.',
      '',
      `Finca: ${data.fincaName}`,
      `NIF/CIF: ${data.nif}`,
      `Código REA: ${data.codigoRea || 'Sin dato'}`,
      `Error: ${data.title}`,
      `Descripción: ${data.description}`,
      `Siguiente paso mostrado: ${data.nextStep}`,
      '',
      'Detalles técnicos:',
      ...this.formatTechnicalDetails(data.technicalDetails),
      '',
      'Gracias.',
    ]);
  }

  public static auditRecordHref(data: ReaAuditSupportEmailData): string {
    return this.buildMailto(`Soporte REA - ${data.title} - ${data.importId}`, [
      'Hola,',
      '',
      'Necesito ayuda con esta importación REA fallida.',
      '',
      `Import ID: ${data.importId}`,
      `Fecha: ${data.createdAt}`,
      `NIF/CIF: ${data.nif}`,
      `Código REA: ${data.codigoRea}`,
      `Estado: ${data.statusCode}`,
      `Error: ${data.title}`,
      `Descripción: ${data.description}`,
      ...this.optionalLine('Siguiente paso mostrado', data.nextStep),
      '',
      'Detalles técnicos:',
      ...this.formatTechnicalDetails(data.technicalDetails),
      '',
      'Gracias.',
    ]);
  }

  private static optionalLine(label: string, value: string): string[] {
    return value.trim() !== '' ? [`${label}: ${value}`] : [];
  }

  private static formatTechnicalDetails(details: ReaTechnicalDetailItem[]): string[] {
    if (details.length === 0) {
      return ['- Sin detalles técnicos disponibles en el histórico.'];
    }

    return details.map((detail) => `- ${detail.label}: ${detail.value}`);
  }

  private static buildMailto(subject: string, bodyLines: string[]): string {
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(bodyLines.join('\n'));

    return `mailto:${this.supportEmail}?subject=${encodedSubject}&body=${encodedBody}`;
  }
}
